import { BoxProps } from 'app/src/kit/primitives/themeMappings/props'

import { TKey, useIntl } from '@weenat/wintl'
import Button from 'app/src/kit/Button'
import Scrollable from 'app/src/kit/Scrollable'

type GenericOnPress<T> = (arg?: T) => void | Promise<void>

export interface AlertCreationStepProps<T> {
  isNextLoading?: boolean
  canProgressToNext?: boolean
  children?: React.ReactNode
  currentStepNumber: number
  isLastStep?: boolean
  isContentScrollable?: boolean
  onPressNext?: GenericOnPress<T>
  onPressPrevious?: GenericOnPress<T>
  previousKey?: TKey
}

function AlertCreationStep<T>({
  isNextLoading = false,
  canProgressToNext = true,
  children,
  currentStepNumber,
  isLastStep = false,
  isContentScrollable = true,
  onPressNext,
  onPressPrevious,
  previousKey = 'actions.previous'
}: AlertCreationStepProps<T>) {
  const { t } = useIntl()

  const ContentHolder = isContentScrollable ? Scrollable : Box
  const contentHolderProps = isContentScrollable
    ? {}
    : ({ height: '100%', style: { overflow: 'auto' } } as BoxProps)

  const nextButton = (
    <Button isDisabled={!canProgressToNext} onPress={onPressNext} isLoading={isNextLoading}>
      {isLastStep ? t('actions.confirm') : t('actions.next')}
    </Button>
  )

  return (
    <Flex $flexDirection='column' $flex={1} $height='100%'>
      <ContentHolder {...contentHolderProps}>{children}</ContentHolder>

      <Flex $alignItems='center' $justifyContent='space-around' $height={48} $m='lg'>
        {onPressPrevious && currentStepNumber > 1 && (
          <Button importance='sd' onPress={onPressPrevious}>
            {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              t(previousKey)
            }
          </Button>
        )}

        {onPressNext ? <>{nextButton}</> : null}
      </Flex>
    </Flex>
  )
}

export default AlertCreationStep
